import { useHistory, useLocation } from "react-router-dom";
import { Layout } from "../../../shared/components/Layout";
import { FormTaxRate } from "../components/FormTaxRate";
import { PATH_TAX_WITHHOLDINGS } from "../paths";

/**
 * The tax profile and the rate are one screen, so this route covers what used to
 * be `RouteEditTaxProfile` too — hence it still honours the `backPath`/`nextPath`
 * that Settings → Tax profile passes through when it deep-links here.
 */
export const RouteEditTaxRate = () => {
  const history = useHistory();
  const location = useLocation<{
    backPath?: string;
    nextPath?: string;
  }>();

  return (
    <Layout title="Tax Withholdings">
      <FormTaxRate
        onBack={() => {
          history.push(location.state?.backPath || PATH_TAX_WITHHOLDINGS);
        }}
        onNext={() => {
          history.push(location.state?.nextPath || PATH_TAX_WITHHOLDINGS);
        }}
        isEdit
      />
    </Layout>
  );
};
